import { createContext, useState } from 'react';
import api from 'services/api';

export const TipoParadaContext = createContext();

export const TipoParadaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [tipoParada, setTipoParada] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getTipoParada = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: tipoParada?.filter,
        page: tipoParada?.page,
        size: tipoParada?.size,
        order: tipoParada?.order,
        ...payload,
      });
      setTipoParada((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <TipoParadaContext.Provider
      value={{
        getLoading,
        tipoParada,
        getTipoParada,
      }}
    >
      {children}
    </TipoParadaContext.Provider>
  );
};
